import { render, staticRenderFns } from "./quesInstru1.vue?vue&type=template&id=576abf5c"
import script from "./quesInstru1.vue?vue&type=script&lang=js"
export * from "./quesInstru1.vue?vue&type=script&lang=js"
import style0 from "./quesInstru1.vue?vue&type=style&index=0&id=576abf5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports